import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Header, Button, Divider, Tab } from "semantic-ui-react";

import LimitTab from "./LimitTab.jsx";
import MiscellaneousTab from "./MiscellaneousTab.jsx";
import SSHKeyTab from "./SSHKeyTab.jsx";

import { selectTestingEnvironment } from "../../state/reducers/config/configSelectors.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class OrganizationTab extends PureComponent {
  static propTypes = {
    testingEnvironment: PropTypes.string,
    user: PropTypes.object.isRequired,
    requestLimitHandler: PropTypes.func.isRequired,
    copy: PropTypes.func.isRequired
  };

  // -- RENDER -- //

  render() {
    const { user, requestLimitHandler, testingEnvironment, copy } = this.props;

    const panes = [];

    if (user.limits && user.businessModel > 0) {
      panes.push({
        menuItem: copy("account.tabs.limits"),
        render: () => (
          <Tab.Pane>
            <LimitTab user={user} requestLimitHandler={requestLimitHandler} />
          </Tab.Pane>
        )
      });
    }

    if (user.hasOwnProperty("inviteInterval")) {
      panes.push({
        menuItem: copy("account.tabs.miscellaneous"),
        render: () => (
          <Tab.Pane>
            <MiscellaneousTab user={user} onSubmit={this.props.onSubmit} />
          </Tab.Pane>
        )
      });
    }

    if (user.sshKeys) {
      panes.push({
        menuItem: copy("account.tabs.ssh_keys"),
        render: () => (
          <Tab.Pane>
            <SSHKeyTab data={user} />
          </Tab.Pane>
        )
      });
    }

    return (
      <Segment vertical padded textAlign="left">
        <Header as="h3">{copy("account.organization.title")}</Header>
        <p>{copy("account.organization.body")}</p>

        <Tab panes={panes} renderActiveOnly={true} />
      </Segment>
    );
  }
}

const mapStateToProps = state => ({
  testingEnvironment: selectTestingEnvironment(state),
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(OrganizationTab);
